import { FunctionComponent, ReactNode } from 'react';
import { Languages } from '../top-menu/top-menu';

export type Props = {
  language: Languages;
  className?: string;
  onClick?: (e: any) => void;
  children: ReactNode;
  style?: React.CSSProperties | undefined;
};

const LI: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      {window.location.href.indexOf('/' + props.language + '/') !== -1 && (
        <li className={props.className} onClick={props.onClick} style={props.style}>
          {props.children}
        </li>
      )}
    </>
  );
};

export default LI;
